import { CoinColor, LikeColor, UserAddColor } from '@viewup/ui';

export const usageLists = [
  {
    content: '뷰업 시작,\n계정\n등록부터!',
    icon: UserAddColor,
    title: 'STEP.1',
    type: 'manage',
    url: 'https://smiledragon.notion.site/1f2d07302a2281e8845cc54ec74bbd6c',
  },
  {
    content: '적립 방법,\n쉽게\n알려드려요!',
    icon: CoinColor,
    title: 'STEP.2',
    type: 'setting',
    url: 'https://smiledragon.notion.site/1f2d07302a228106b103f130eb74e72c',
  },
  {
    content: '한번에\n마스터하는\n포인트, 환급',
    icon: LikeColor,
    title: 'STEP.3',
    type: 'viewing',
    url: 'https://smiledragon.notion.site/1f2d07302a2281c29f86deda458770c5',
  },
];
